/**
 * Created with IntelliJ IDEA.
 * User: livnato
 * Date: 3/19/13
 * Time: 7:59 AM
 * To change this template use File | Settings | File Templates.
 */
define(function (require) {
    "use strict";

    var Backbone = require('backbone');

    var InlineTextareaModel = Backbone.Model.extend({
        defaults : {
            value: '',
            label:'',
            placeholder:'',
            lastKnownGoodValue: '',
            enabled: true
        },

        initialize : function () {
        },

        //It used to validate maxChars limit, however according to PM's requirement the validation was removed. For future changes the validate method remains.
        validate : function (val) {
            return true;
        },

        reset : function () {
        }

    });

    return InlineTextareaModel;
});
